import { MprcIconButtonDropdown } from "components";
import { IconSort } from "components/icons";
import { GlobalSearchOrderBy } from "generated/CoreApi_v1";
import { useTranslation } from "react-i18next";

export const GlobalSearchOrderByComponent = ({ selectedOption, onChange }: { selectedOption: GlobalSearchOrderBy; onChange: (selectedOption: GlobalSearchOrderBy) => void; }) => {
    const { t } = useTranslation("shared");
    return (
        <MprcIconButtonDropdown
            title={t("shared:Filter.OrderBy")}
            icon={<IconSort />}
            onChange={(selected) => onChange(selected)}
            selected={selectedOption}
            menuItemCheck
            items={
                [
                    { text: t("GlobalSearch.Filters.OrderBy.Relevance"), value: GlobalSearchOrderBy.Relevance },
                    { text: t("GlobalSearch.Filters.OrderBy.Recent"), value: GlobalSearchOrderBy.Recent },
                    { text: t("GlobalSearch.Filters.OrderBy.Viewed"), value: GlobalSearchOrderBy.Viewed },
                    { text: t("GlobalSearch.Filters.OrderBy.Liked"), value: GlobalSearchOrderBy.Liked },
                ]
            }
        />
    );
};
